"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeViewPanelControl = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const join_1 = tslib_1.__importDefault(require("../../components/utils/join"));
const GeneralConstants = tslib_1.__importStar(require("../../Utilities/Constants/GeneralConstants"));
const ThemeSelector_1 = require("./ThemeSelector");
const ThemeViewPanelControl = (props) => {
    const elementType = props.viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
    return (React.createElement("div", { className: (0, join_1.default)(props.accessLevel == 'ReadOnly' ? GeneralConstants.READ_ONLY_STYLE : '', `ab-${elementType}__Theme__wrap`) },
        React.createElement(ThemeSelector_1.ThemeSelector, null)));
};
exports.ThemeViewPanelControl = ThemeViewPanelControl;
